import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overview"
}
const _hoisted_2 = {
  key: 1,
  style: {"width":"100%","height":"100px","display":"flex","align-items":"center","justify-content":"center"}
}

import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import SvgDisplay from '@/design-system/atoms/SvgDisplay.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDisplayOverview',
  props: {
    isLoading: { type: Boolean },
    overviewData: {},
    showForEntityTypes: {},
    title: {}
  },
  setup(__props: any) {



const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)

function iconSource(itemType: string) {
  switch (itemType) {
    case 'COMPLEX':
      return 'Icon-Levels-Complexes'
    case 'REAL_ESTATE':
      return 'Icon-Levels-Real-Estates-Small'
    case 'CONSTRUCTION':
      return 'Icon-Levels-Constructions'
    case 'LEVEL':
      return 'Icon-Levels-Floors-Small'
    case 'SPACE':
      return 'Icon-Levels-Rooms-Small'
    default:
      return 'Icon-Blank'
  }
}

return (_ctx: any,_cache: any) => {
  return (!_ctx.isLoading && _ctx.showForEntityTypes.includes(_unref(clickedEntityType)))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overviewData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "overview__row"
          }, [
            _createVNode(SvgDisplay, {
              src: iconSource(item.itemType),
              class: "overview__row__icon"
            }, null, 8, ["src"]),
            _createElementVNode("div", null, _toDisplayString(item.itemValue) + " " + _toDisplayString(item.itemTitle.toLowerCase()), 1)
          ]))
        }), 128))
      ]))
    : (_ctx.showForEntityTypes.includes(_unref(clickedEntityType)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(PulseLoader, {
            loading: true,
            color: "#3F46D6"
          })
        ]))
      : _createCommentVNode("", true)
}
}

})